import { createSelector } from 'reselect';
import PredesComplianceMissingMandatoryElementsKeyDetailsColumns
  from '../../containers/PredesComplianceMissingMandatoryElementsKeyDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMissingMandatoryElementsKeyDetailsColumns);
